import {
	EuiRadioGroup,
} from '@equipmentshare/ds2'

type AcquisitionMethodSelectProps = {
	value?: 'purchase_order' | 'direct_vendor' | 'credit_card_purchase',
	onChange: ( acquisitionMethod: 'purchase_order' | 'direct_vendor' | 'credit_card_purchase' ) => void,
}

const ACQUISITION_METHOD_OPTIONS = [
	{
		id: 'purchase_order',
		label: 'Via Purchase Order'
	},
	{
		id: 'credit_card_purchase',
		label: 'Credit Card Purchase'
	},
	{
		id: 'direct_vendor',
		label: 'Other'
	}
]

export default function AcquisitionMethodSelect( {
	value,
	onChange
}: AcquisitionMethodSelectProps ) {
	const onSelectionChange = ( optionId: string ) => {
		onChange( optionId as 'purchase_order' | 'direct_vendor' | 'credit_card_purchase' )
	}

	return (
		<EuiRadioGroup
			options={ACQUISITION_METHOD_OPTIONS}
			idSelected={value}
			onChange={onSelectionChange}
		/>
	)
}
